import { render, staticRenderFns } from "./FarmForm.vue?vue&type=template&id=d32cb0ee&"
import script from "./FarmForm.vue?vue&type=script&lang=ts&"
export * from "./FarmForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports